import React from 'react';
import {useState, useEffect} from 'react';
import {Modal, Table,} from 'antd';
import i18n from "../../../i18n";


export default function ModalDriverInfoLite({
                                              driver,
                                              isShow,
                                              setIsShow
                                            }) {
  const driverInfoAliases = {
    Name: i18n.t('constants.driverInfoAliases.fio'),
    Phone: i18n.t('constants.driverInfoAliases.phone'),
  }
  const [tableData, setTableData] = useState([]);

  const [columns, setColumns] = useState([
    {
      title: '',
      key: 'name',
      render: record => {
        if (record.isBoldText) {
          return (<b>{record.name}</b>);
        }
        return record.name;
      }
    },
    {
      title: '',
      key: 'data',
      render: record => {
        if (record.name === "Моб. номер") {
          return (
            <React.Fragment>
              <a href={`tel:${record.data}`} className='active'>
                {record.data}
              </a>
            </React.Fragment>
          )
        } else {
          if (record.data === 0 || record.data === 1) {
            return record.data ? i18n.t('main.yes') : i18n.t('main.no');
          }
          return record.data
        }
      }
    },
  ]);

  useEffect(() => {
    if (isShow && driver) {
      let data = [];

      Object.keys(driver).forEach((element) => {
        if (driver[element] !== null && driver[element] !== '') {
          if (typeof driverInfoAliases[element] !== 'undefined')
            data.push(
              {
                name: driverInfoAliases[element],
                data: driver[element],
                isBoldText: element === 'Name'
              }
            );
        }
      });

      console.log(driver);

      setTableData(data);
    }
  }, [isShow]);


  return (
    <Modal
      title={i18n.t('modals.modalDriverInfo.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      footer={<></>}
      onCancel={() => {
        setIsShow(false);
      }}
    >
      <Table
        columns={columns}
        dataSource={tableData}
        showHeader={false}
        pagination={false}
        size='small'
      >

      </Table>

    </Modal>
  )
}
